import React from "react";
import { ShieldCheck } from "lucide-react";

export default function PrivacyNotice() {
  return (
    <div
      data-testid="privacy-notice"
      className="mt-8 mb-2 bg-emerald-50/60 border border-emerald-200/70 rounded p-4 flex items-start gap-3"
    >
      <div className="w-8 h-8 rounded flex items-center justify-center bg-white border border-emerald-200 text-emerald-600 shrink-0">
        <ShieldCheck size={16} />
      </div>
      <div className="text-sm text-slate-700 leading-relaxed">
        <div className="text-[11px] uppercase tracking-widest text-emerald-700 font-semibold mb-0.5">
          Your Data Is Private
        </div>
        We respect your privacy. Your data is not sold, shared, or provided to
        any third party. It is used only to provide and operate the services
        available in this application.
      </div>
    </div>
  );
}
